import { useEffect, useRef } from "react";

const items = [
  {
    icon: "ri-focus-3-line",
    label: "Missão",
    color: "#C8A63A",
    bg: "linear-gradient(135deg, #0A2472, #1F4ED8)",
    text: "Oferecer aos nossos clientes uma advocacia de excelência, célere e, sobretudo, eficiente, na busca pela efetivação de seus direitos, face às abusividades que contra eles são cometidas.",
  },
  {
    icon: "ri-eye-line",
    label: "Visão",
    color: "#4EA3D8",
    bg: "linear-gradient(135deg, #1F4ED8, #4EA3D8)",
    text: "O escritório Quelen Manske – QM – tem como visão o reconhecimento da prestação de um trabalho de excelência, para que nossos clientes tenham preservados seus direitos mais importantes: a vida, a saúde, seus bens e o seu trabalho.",
  },
  {
    icon: "ri-heart-3-line",
    label: "Valores",
    color: "#E6D18A",
    bg: "linear-gradient(135deg, #C8A63A, #E6D18A)",
    text: "No escritório Quelen Manske – QM – temos enorme respeito aos nossos clientes e, por isso, atuamos com total ética e transparência na defesa de seus direitos. Aqui, vocês são nossos parceiros de vida e de jornada!",
  },
];

export default function MissaoVisaoValores() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll(".mvv-fade").forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = "1";
                (el as HTMLElement).style.transform = "translateY(0)";
              }, i * 180);
            });
          }
        });
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="missao-visao-valores"
      ref={sectionRef}
      className="py-24"
      style={{ background: "#0A2472" }}
    >
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div
          className="text-center mb-16 mvv-fade"
          style={{ opacity: 0, transform: "translateY(20px)", transition: "opacity 0.7s ease, transform 0.7s ease" }}
        >
          <div className="inline-flex items-center gap-3 mb-4">
            <div className="w-10 h-px" style={{ background: "#C8A63A" }} />
            <span
              className="text-xs font-semibold tracking-[0.3em] uppercase"
              style={{ color: "#C8A63A", fontFamily: "'Inter', sans-serif" }}
            >
              Nossos Pilares
            </span>
            <div className="w-10 h-px" style={{ background: "#C8A63A" }} />
          </div>
          <h2
            className="text-3xl md:text-4xl font-bold text-white"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Missão, Visão e Valores
          </h2>
          <p
            className="text-white/60 mt-4 max-w-xl mx-auto text-sm leading-relaxed"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Os princípios que guiam cada decisão, cada caso e cada conquista do escritório QM Advocacia.
          </p>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {items.map((item, i) => (
            <div
              key={item.label}
              className="mvv-fade rounded-lg overflow-hidden group hover:-translate-y-1 transition-all duration-300"
              style={{
                opacity: 0,
                transform: "translateY(24px)",
                transition: `opacity 0.7s ease ${i * 0.18}s, transform 0.7s ease ${i * 0.18}s`,
                background: "rgba(255,255,255,0.05)",
                border: "1px solid rgba(255,255,255,0.10)",
              }}
            >
              {/* Top accent bar */}
              <div className="h-1 w-full" style={{ background: item.color }} />

              <div className="p-8">
                {/* Icon + Label */}
                <div className="flex items-center gap-4 mb-6">
                  <div
                    className="w-12 h-12 flex items-center justify-center rounded-lg flex-shrink-0"
                    style={{ background: item.bg }}
                  >
                    <i
                      className={`${item.icon} text-xl`}
                      style={{ color: "#fff" }}
                    />
                  </div>
                  <h3
                    className="text-2xl font-bold"
                    style={{ color: item.color, fontFamily: "'Cormorant Garamond', serif" }}
                  >
                    {item.label}
                  </h3>
                </div>

                {/* Divider */}
                <div
                  className="w-10 h-px mb-6"
                  style={{ background: `${item.color}60` }}
                />

                {/* Text */}
                <p
                  className="text-white/75 text-sm leading-relaxed"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {item.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
